import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiDetailPageHeader, MiPageHeader } from "@miplatform/components";
import { ICONS_WEB, PERMISSIONS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { ErrorPage } from "@mibuildweb/components";
import { usePermissions } from "@mibuildweb/hooks";
import { Box, Divider } from "@mui/material";
import { INVOICING_ROUTES } from "../accountingConstants";
import { ReconcileProvider, useReconcileContext } from "./ReconcileContext";
import { ReconcileDocumentsSection } from "./ReconcileDocumentsSection/ReconcileDocumentsSection";
import { ReconcileFooter } from "./ReconcileFooter/ReconcileFooter";
import { ReconcileInvoiceSection } from "./ReconcileInvoiceSection/ReconcileInvoiceSection";

const ReconcileContent = memo(() => {
  const { classes } = useStyles();
  const { order, isLoading, viewMode } = useReconcileContext();

  const { hasPermission } = usePermissions();

  if (!hasPermission(PERMISSIONS.BILLING_COMMITMENT.READ)) {
    return <ErrorPage />;
  }

  const getHeaderTitle = () => {
    switch (viewMode) {
      case INVOICING_ROUTES.INVOICE:
        return "Invoice";
      case INVOICING_ROUTES.INVOICED:
        return "Invoiced";
      case INVOICING_ROUTES.PRE_BILL:
        return "Order Pre-Bill";
      default:
        return "";
    }
  };

  return (
    <>
      <MiDetailPageHeader
        title={order?.home?.address?.addressLine1}
        subTitles={
          order?.home
            ? [
                `${order.home?.address?.city}, ${order.home?.address?.regionCode}`,
                order.home?.communityName,
                order.home?.builderName,
              ]
            : undefined
        }
        titleIcon={mdi[ICONS_WEB.CHEVRON_LEFT]}
        loading={isLoading}
      />
      <Box margin={3} height="100%" display="flex" flexDirection="column">
        <Box className={classes.header}>
          <MiPageHeader
            title={
              order
                ? `${order.orderTemplateName} ${getHeaderTitle()}`
                : undefined
            }
            subTitles={[order?.orderNumber]}
          />
          <Divider />
        </Box>
        <Box display="flex" width="100%" height="100%" flexWrap="wrap">
          <ReconcileInvoiceSection />
          <Divider orientation="vertical" flexItem />
          <ReconcileDocumentsSection />
        </Box>
      </Box>
      {viewMode !== INVOICING_ROUTES.INVOICED && <ReconcileFooter />}
    </>
  );
});

export const Reconcile = memo(() => {
  const {
    params: { id },
    location,
  } = useRouter();

  const pathParts = location.pathname.split("/");
  const viewMode = pathParts[pathParts.length - 1];

  return (
    <ReconcileProvider orderId={id} viewMode={viewMode}>
      <ReconcileContent />
    </ReconcileProvider>
  );
});

const useStyles = makeStyles()((theme) => ({
  header: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
}));
